import moment from "moment";

/**
 * Compute age in years from date of birth.
 * @param {string|Date|null|undefined} d - Date of birth
 * @returns {number|undefined} Age in years
 */
export function ageCalculator(d) {
  if (d == null) return undefined;
  const dob = new Date(d);
  const month_diff = Date.now() - dob.getTime();
  const age_dt = new Date(month_diff);
  const year = age_dt.getUTCFullYear();
  return Math.abs(year - 1970);
}

/**
 * Map a single raw meeting document (backend aggregation shape) to the row shape used by AG Grid.
 * @param {object} d - Raw meeting document from getAppointment / getAppointmentByStatus
 * @param {string} lang - Language code ('EN' or 'HE')
 * @returns {object|null} Row object with keys like "Meeting Id", "Created Date", "MeetingStatus", "data", etc.
 */
export function mapMeetingToRow(d, lang) {
  if (!d) return null;
  return {
    "Meeting Id": d._id,
    "Created Date": new Date(d.createdAt),
    "Schedule Date": d?.scheduledDate ? new Date(d?.scheduledDate) : null,
    "Client Name": `${d.clientData?.first_name || ""} ${d?.clientData?.last_name || ""}`.trim(),
    "Physician Name":
      d?.doctorData?.first_name
        ? `${d?.doctorData?.first_name || ""} ${d?.doctorData?.last_name || ""}`.trim()
        : d?.offerDates?.length !== 0 &&
          d?.offerDates?.[0]?.doctorUserDetails &&
          d?.statuses !== "Scheduled"
        ? `${d?.offerDates[0]?.doctorUserDetails[0]?.first_name || ""} ${d?.offerDates[0]?.doctorUserDetails[0]?.last_name || ""}`.trim()
        : null,
    consultingField: lang === "EN" ? d?.consultation?.eng : d?.consultation?.heb,
    MeetingStatus: d.statuses,
    Comments: d.comments,
    ClientId: d.ClientId,
    data: d,
    "Request Description": d?.requestDescription,
    Age: ageCalculator(d?.meetingpatientdetails?.patientDOB),
    Email: d?.meetingpatientdetails?.patientEmail,
    "Client Id": d?.ClientId,
    DOB: moment(d?.meetingpatientdetails?.patientDOB).format("DD-MM-YYYY"),
    Gender: d?.clientData?.clientGender,
    Phone: d?.meetingpatientdetails?.patientPhone,
    "Marital Status": d?.meetingpatientdetails?.patientMaritalStatus,
    Address: d?.clientData?.clientAddress?.country,
  };
}
